import axios from 'axios'
import library from '../../../utils/Library'

export const getAllInternalRecycleBin = async (params) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('storage') + '/internalrecyclebin'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: params
  })
}
